import React, { ReactElement } from 'react';
import { Link } from 'idsk-react-components';
import { useParams } from 'react-router';
import routes from '../routing/routes';

interface Props {
  messages: Array<string>;
  title: string;
}

export default ({ messages, title }: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();
  return (
    <>
      <h1>{title}</h1>
      {messages.map((message) => (
        <p key={message}>{message}</p>
      ))}
      <p>
        <Link to={routes.pripomienky.list.withParams(type, year, index)} type="button-secondary">
          Späť na zoznam
        </Link>
      </p>
    </>
  );
};
